if (typeof WDN === 'undefined') {
  var WDN = {};
}

if (typeof WDN.RenderTemplate === 'undefined') {
  WDN.RenderTemplate = (function () {
    var Query, _generateQueryUrl, _sendRequest, validate, clearLoading;

    Query = function (obj) {
      if (validate(obj)) {
        var output = document.querySelector(obj.target);
        if (output) {
          var link = obj.url;
          // if it's object, we are generating product search query url
          if (typeof obj.url === 'object') {
            link = _generateQueryUrl(obj);
          }
          _sendRequest(link, output, obj.callback);
        }
      } else {
        console.warn('Missing parameters for WDN.RenderTemplate');
      }
    };

    validate = function (obj) {
      return !!(obj.url && obj.target);
    };

    clearLoading = function (target) {
      target.removeAttribute('data-loading');
    };

    _sendRequest = function (url, target, callback) {
      WDN.Request.Get({
        url: url,
        onSuccess: function (res) {
          // success callback
          clearLoading(target);
          target.insertAdjacentHTML('beforeend', res);
          typeof callback === 'function' ? callback() : '';
        },
        onError: function (res) {
          // error callback
          console.log('error');
        },
      });
    };

    _generateQueryUrl = function (obj) {
      var url =
        '/search?view=' +
        obj.template +
        '&type=product&q=id:' +
        obj.url.join('%20OR%20id:');

      return url;
    };

    return {
      query: Query,
    };
  })();
}

if (typeof WDN === "undefined") {
  var WDN = {};
}

if (typeof WDN.Request === "undefined") {
  WDN.Request = (function () {
    // Private function
    var _do;

    // Public function
    var Get, Post;

    _do = function (obj) {
      var req = new XMLHttpRequest();

      if (obj.method == "POST" || obj.method == "PUT") {
        req.open(obj.method, obj.url);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      }

      req.onreadystatechange = function () {
        if (req.readyState == 4) {
          if (req.status == 404 || req.status == 400) {
            if (obj.onError) {
              obj.onError(req.responseText);
            }
          }
          if (req.status == 200) {
            if (obj.onSuccess) {
              obj.onSuccess(req.responseText);
            }
          }
        }
      };

      if (obj.method == "POST" || obj.method == "PUT") {
        req.send(JSON.stringify(obj.data));
      } else {
        req.open("GET", obj.url, true);
        req.send(null);
      }
    };

    Get = function (obj) {
      _do({
        method: "GET",
        url: obj.url,
        onSuccess: function (res) {
          obj.type == "JSON"
            ? obj.onSuccess(JSON.parse(res))
            : obj.onSuccess(res);
        },
        onError: function (res) {
          if (obj.onError) {
            if (obj.type == "JSON") {
              obj.onError(JSON.parse(res));
            } else {
              obj.onError(res);
            }
          }
        },
      });
    };

    Post = function (obj) {
      _do({
        method: "POST",
        url: obj.url,
        data: obj.data,
        onSuccess: function (res) {
          obj.onSuccess(JSON.parse(res));
        },
        onError: function (res) {
          if (obj.onError) {
            obj.onError(res);
          }
        },
      });
    };

    return {
      Get: Get,
      Post: Post,
    };
  })();
}

if (typeof WDN.Cart === "undefined") {
  WDN.Cart = (function () {
    // Include WDN.Request
    var Request = WDN.Request;

    if (!Request) {
      console.warn("Could not include WDN.Cart. WDN.Request was not found");
      return false;
    }

    // Public
    var Add, Update, Change, Get, Remove, Clear;

    // Private helpers
    var isFunction;

    isFunction = function (func) {
      return typeof func === "function";
    };

    var Routes = {
      add: "/cart/add.js",
      get: "/cart.js",
      update: "/cart/update.js",
      clear: "/cart/clear.js",
      change: "/cart/change.js",
    };

    Get = function (obj) {
      Request.Get({
        url: Routes.get,
        onSuccess: function (res) {
          onCartUpdate(res, "get");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "get");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
        type: "JSON",
      });
    };

    Add = function (obj) {
      Request.Post({
        url: Routes.add,
        data: obj.data,
        onSuccess: function (res) {
          onCartUpdate(res, "add");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "add");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
      });
    };

    Update = function (obj) {
      Request.Post({
        url: Routes.update,
        data: obj.data,
        onSuccess: function (res) {
          onCartUpdate(res, "update");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "update");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
      });
    };

    Clear = function (obj) {
      Request.Post({
        url: Routes.clear,
        onSuccess: function (res) {
          onCartUpdate(res, "clear");
          if (obj) {
            if (isFunction(obj.onSuccess)) {
              obj.onSuccess(res);
            }
          }
        },
        onError: function (res) {
          onCartUpdate(res, "clear");
          if (obj) {
            if (isFunction(obj.onError)) {
              obj.onError(res);
            }
          }
        },
      });
    };

    Remove = function (obj) {
      var data = {
        updates: { [obj.id]: 0 },
      };
      Update({ data: data, onSuccess: obj.onSuccess });
    };

    Change = function (obj) {
      Request.Post({
        url: Routes.change,
        data: obj.data,
        onSuccess: function (res) {
          onCartUpdate(res, "change");
          if (isFunction(obj.onSuccess)) {
            obj.onSuccess(res);
          }
        },
        onError: function (res) {
          onCartUpdate(res, "change");
          if (isFunction(obj.onError)) {
            obj.onError(res);
          }
        },
      });
    };

    var onCartUpdate = function (res, action) {
    };

    return {
      Add: Add,
      Update: Update,
      Get: Get,
      Remove: Remove,
      Clear: Clear,
      Change: Change,
    };
  })();
}

if (typeof WDN._Storage === "undefined") {
  WDN._Storage = (function () {
    var Config = {
      local: "local",
      session: "session",
    };

    var Constructor = function (cookie, config, cookieConfig) {
      this.cookie = cookie;
      this.config = config || false;
      this.cookieConfig = cookieConfig || {};
      this.memory = [];
      this.storageType = cookieConfig.type || false;

      // Callback
      // Provided by config obj (optional)
      this._onCookieChange = function (eventName) {
        if (config) {
          if (config.onCookieChange) {
            config.onCookieChange.call(this, eventName);
          }
        }
      };

      this._found = function (handle) {
        return !!this._findItem(handle);
      };

      this._findIndex = function (handle) {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.memory = JSON.parse(this.read());
        } else {
          this.memory = this.read();
        }
        return this.memory
          .map(function (item, index) {
            if (item.handle == handle || item.id == handle) {
              return index;
            }
          })
          .filter(function (_item) {
            if (_item !== undefined) {
              return true;
            }
          })[0];
      };
      this._findItem = function (handle) {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.memory = JSON.parse(this.read());
        } else {
          this.memory = this.read();
        }
        
        return this.memory.filter(function (item) {
          if (item.handle === handle || item.id == handle) {
            return item;
          }
        })[0];
      };

      // Actual add function
      this._add = function (obj, eventName) {
        this.memory.push(obj);
        Cookies.set(this.cookie, this.memory, this.cookieConfig);
        this._onCookieChange(eventName);
      };

      this.add = function (obj) {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.memory = this.readStorage(true);
        } else {
          this.memory = this.read(true);
        }

        // If already found
        if (this._found(obj.handle)) {
          // Add duplicate if config tells us to
          if (this.config) {
            if (this.config.duplicate) {
              this._add(obj, "updated");
            }
          }
        } else {
          this._add(obj, "added");
        }
      };

      this.remove = function (handle) {
        this.memory = this.read();
        if (this._found(handle)) {
          var foundIndex = this._findIndex(handle);
          this.memory.splice(foundIndex, 1);

          Cookies.set(this.cookie, this.memory, this.cookieConfig);
          this._onCookieChange("removed");
        }
      };

      this.read = function (no_event) {
        if (!no_event) {
          this._onCookieChange("read");
        }
        return Cookies.getJSON(this.cookie);
      };

      this.count = function () {
        return this.read().length;
      };

      this.clear = function () {
        Cookies.delete(this.cookie);
        this._onCookieChange("cleared");
      };

      this.clearStorage = function () {
        if (this.storageType == Config.local) {
          localStorage.removeItem(this.cookie);
        } else {
          sessionStorage.removeItem(this.cookie);
        }
      };

      this.readStorage = function () {
        if (this.storageType == Config.local) {
          return localStorage.getItem(this.cookie);
        } else {
          return sessionStorage.getItem(this.cookie);
        }
      };

      this.setEmptyStorage = function () {
        if (this.storageType == Config.session) {
          sessionStorage.setItem(this.cookie, "[]");
        } else {
          localStorage.setItem(this.cookie, "[]");
        }
      };

      this._addStorageItem = function (obj, eventName) {
        this.memory = JSON.parse(this.read()) || [];
        if (this.cookie === 'Wishlist' && this.memory.some(function (item) { return item.id == obj.id; })) return;
        this.memory.push(obj);
        if (this.storageType == Config.session) {
          sessionStorage.setItem(this.cookie, JSON.stringify(this.memory));
        } else {
          localStorage.setItem(this.cookie, JSON.stringify(this.memory));
        }
        this._onCookieChange(eventName);
      };

      this._removeStorageItem = function (handle) {
        this.memory = JSON.parse(this.read());
        if (this._found(handle)) {
          this.memory = this.memory.filter(function (item) {
            return item.id != handle && item.handle != handle;
          });
          if (this.storageType == Config.session) {
            sessionStorage.setItem(this.cookie, JSON.stringify(this.memory));
          } else {
            localStorage.setItem(this.cookie, JSON.stringify(this.memory));
          }
          this._onCookieChange("removed");
        }
      };

      this.setStorageType = function () {
        if (
          this.storageType == Config.local ||
          this.storageType == Config.session
        ) {
          this.remove = this._removeStorageItem;
          this._add = this._addStorageItem;
          this.storeEmptyData = this.setEmptyStorage;
          this.read = this.readStorage;
          this.clear = this.clearStorage;
        }
      };

      this.storeEmptyData = function () {
        Cookies.set(this.cookie, [], this.cookieConfig);
      };

      this.init = function () {
        this.setStorageType();
        if (!this.read(true)) {
          this.storeEmptyData();
        }
      };

      this.init();
    };

    return {
      Constructor: Constructor,
    };
  })();
}

if (typeof WDN.Wishlist === 'undefined') {
  WDN.Wishlist = (function () {
    // nodes
    var __assignNewNodes, __generateNodes, __initNodes;
    var Nodes = {};
    //priv
    var init, createInstance, initOutput, _collectIds;
    // priv - render
    var renderWishlist, renderEmptyLayout;
    //priv - loading
    var setLoadingState, clearLoadingState;
    // priv - main action
    var bindMainAddToCart, mainAddToCartHandler, _addToCartCall;

    //priv - output
    var OutputItem, bindOutput;
    // wishlist variables
    var Icons = {};
    var OutputItems = {};
    var Icon;

    // empty variable, will be populated with nodes
    var outputNodes;

    // callbacks
    var setCallbacks;
    var Callbacks = {};

    var Nodelist = [
      {
        name: 'wishlist',
        list: {
          iconAll: '[data-wishlist-icon]',
          output: '[data-wishlist-output]',
          countAll: '[data-wishlist-count]',
          clearList: '[data-wishlist-clear]'
        },
      },
      {
        name: 'wishlistMain',
        list: {
          addall: '[data-wishlist-addall]',
        },
        onInit: false,
      },
      {
        name: 'output',
        list: {
          itemAll: '[data-wishlist-output-item]',
          addToCart: '[data-wishlist-addtocart]',
          checkboxAll: '[data-wishlist-checkbox]',
          checkedCheckboxesAll: '[data-wishlist-checked]',
          removeItem: '[data-wishlist-remove]',
          variantSelect: '[data-wishlist-select]',
        },
        onInit: false,
      },
    ];

    __initNodes = function () {
      for (var key in Nodelist) {
        if (Nodelist.hasOwnProperty(key)) {
          if (typeof Nodelist[key].onInit === 'undefined') {
            var keyName = Nodelist[key];
            Nodes[keyName.name] = __generateNodes(Nodelist[key]);
          }
        }
      }
    };

    __generateNodes = function (obj) {
      var newObj = {};
      newObj.names = obj.list;
      newObj.selectors = {};

      for (key in obj.list) {
        var val = obj.list[key];

        if (val.indexOf('[') === -1) {
          val = '.' + val;
        }

        newObj.selectors[key] = val;

        // Grab all of them if name contains All
        if (key.indexOf('All') > -1) {
          newObj[key] = document.querySelectorAll(val);
          continue;
        }

        newObj[key] = document.querySelector(val);
      }

      return newObj;
    };

    __assignNewNodes = function (name) {
      for (var key in Nodelist) {
        if (Nodelist.hasOwnProperty(key)) {
          if (Nodelist[key].name == name) {
            return (Nodes[Nodelist[key].name] = __generateNodes(Nodelist[key]));
            break;
          }
        }
      }
    };

    var WishList = new WDN._Storage.Constructor(
      'Wishlist',
      {
        onCookieChange: function (eventName) {},
      },
      {
        type: 'local',
      }
    );
  
    var WishlistData = JSON.parse(WishList.read());
    var seenWishlistIds = {};
    WishlistData = WishlistData.filter(function (item) {
      if (seenWishlistIds[item.id]) return false;
      seenWishlistIds[item.id] = true;
      return true;
    });
    localStorage.setItem('Wishlist', JSON.stringify(WishlistData));

    Icon = function (item) {
      this.id = parseInt(item.dataset.id);
      this.item = item;
      this.wishlisted = false;
      this._refreshItemState();
      this._updateItemState();
      this.bind();
    };

    Icon.prototype.bind = function () {
      this.item.addEventListener('click', this._handleOnClick.bind(this));
    };

    Icon.prototype._refreshItemState = function () {
      this.wishlisted = !!WishList._findItem(this.id);
    };

    Icon.prototype._updateItemState = function () {
      var id = this.id, wishlisted = this.wishlisted;
      document.querySelectorAll('[data-wishlist-icon]').forEach(function (icon) {
        if (icon.dataset.id != id) return;
        if (wishlisted) icon.setAttribute('data-item-wishlisted', '');
        else icon.removeAttribute('data-item-wishlisted');
      });
    };

    Icon.prototype.add = function () {
      var id = this.id;
      WishList._addStorageItem({ id: id }); // not use object
    };

    Icon.prototype.remove = function () {
      WishList._removeStorageItem(this.id);
    };

    Icon.prototype.setWishlistedState = function () {
      this.item.setAttribute('data-item-wishlisted', '');
    };

    Icon.prototype.clearWishlistedState = function () {
      this.item.removeAttribute('data-item-wishlisted');
    };

    // Pre click
    Icon.prototype._handleOnClick = function () {
      this.onClick();
      this._refreshItemState();
    };

    // Called whenever a heart icon is clicked
    Icon.prototype.onClick = function () {
      this.validateRequest();
      this._refreshItemState();
      this._updateItemState();
      _setItemCount();
    };

    Icon.prototype.validateRequest = function () {
      this._refreshItemState();
      if (this.wishlisted) {
        this.remove();
      } else {
        this.add();
      }
    };

    createInstance = function () {
      if (Nodes.wishlist.iconAll.length > 0) {
        Nodes.wishlist.iconAll.forEach(function (icon) {
          var newObj = icon._luxivoWishlistInstance;
          if (!newObj) {
            newObj = new Icon(icon);
            icon._luxivoWishlistInstance = newObj;
          } else {
            newObj._refreshItemState();
            newObj._updateItemState();
          }
          Icons[icon.dataset.id] = newObj;
        });
      }
    };

    _collectIds = function () {
      var Ids = [];
      WishlistData.forEach(function (data) {
        Ids.push(data.id);
      });
      return Ids;
    };

    initOutput = function () {
      if (Nodes.wishlist.output) {
        setLoadingState();
        if (WishlistData.length > 0) {
          renderWishlist();
        } else {
          renderEmptyLayout();
        }
      }
    };

    renderEmptyLayout = function () {
      Nodes.wishlist.output.textContent = '';
      WDN.RenderTemplate.query({
        url: '?view=empty-favorites',
        target: Nodes.wishlist.selectors.output,
        callback: function () {
          clearLoadingState();
        },
      });
    };

    setLoadingState = function () {
      Nodes.wishlist.output.setAttribute('data-loading', '');
    };

    clearLoadingState = function () {
      Nodes.wishlist.output.removeAttribute('data-loading');
    };
  
  
    _resortItemsOnWishlist = function() {
      var idList = _collectIds();

      if (idList.length > 0) {
        idList.forEach(function(idItem, index) {
          var target = document.querySelector('[data-wishlist-output-item][data-id="' + idItem + '"]');

          if (target) {
            target.style.order = index;
            
            if ((index + 1) == idList.length) {
              target.classList.add('Wishlist__grid-item--first'); 
            }
          }
        });
      }
    }

    renderWishlist = function () {
      WDN.RenderTemplate.query({
        url: _collectIds(),
        target: Nodes.wishlist.selectors.output,
        template: 'favorites',
        callback: function () {
          clearLoadingState();
          bindOutput();
          bindMainAddToCart();
          _listenForClearAll();
          _resortItemsOnWishlist();
        },
      });
    };

    bindOutput = function () {
      outputNodes = __assignNewNodes('output');
      outputNodes.itemAll.forEach(function (item) {
        var newObj = new OutputItem(item);
        OutputItems[item.dataset.id] = newObj;
      });
    };

    OutputItem = function (item) {
      this.id = item.dataset.id;
      this.item = item;
      this.select = item.querySelector(outputNodes.selectors.variantSelect);
      this.addToCart = item.querySelector(outputNodes.selectors.addToCart);
      this.remove = item.querySelector(outputNodes.selectors.removeItem);
      this.checkbox = item.querySelector(outputNodes.selectors.checkboxAll);
      this.bind();
    };

    OutputItem.prototype.bind = function () {
      this.addToCart.addEventListener('click', this.onAddHandler.bind(this));
      this.remove.addEventListener('click', this.removeHandler.bind(this));
      if (this.select) {
        this.select.addEventListener('change', this.selectHandler.bind(this));
      }
      if (this.checkbox) {
        this.checkbox.addEventListener('click', this.checkboxOnClick.bind(this));
      }
    };

    OutputItem.prototype.checkboxOnClick = function () {
      if (this.checkbox.dataset.wishlistChecked === '') {
        this.checkbox.removeAttribute('data-wishlist-checked');
      } else {
        this.checkbox.setAttribute('data-wishlist-checked', '');
      }
    };

    OutputItem.prototype.getVariantId = function () {
      if (this.select) {
        var index = this.select.selectedIndex;
        return this.select.options[index].value;
      } else {
        return this.addToCart.dataset.id;
      }
    };

    OutputItem.prototype.selectHandler = function () {
      this.removeSelectHiglight();
    };

    OutputItem.prototype.validateVariant = function () {
      var isValidated = false;
      if (this.select) {
        if (this.select.selectedIndex === 0) {
          this.higlightSelect();
        } else {
          isValidated = true;
        }
      } else {
        isValidated = true;
      }
      return isValidated;
    };

    OutputItem.prototype.higlightSelect = function () {
      this.select.setAttribute('data-required', '');
    };

    OutputItem.prototype.removeSelectHiglight = function () {
      this.select.removeAttribute('data-required');
    };

    OutputItem.prototype.onAddHandler = function () {
      if (this.validateVariant()) {
        this.addHandler();
      }
    };

    OutputItem.prototype.addHandler = function () {
      var variantId = this.getVariantId();
      WDN.Cart.Add({
        data: {
          items: [
            {
              quantity: 1,
              id: variantId,
            },
          ],
        },
        onSuccess: function () {
          if (typeof Callbacks.onAddToCart === 'function') {
            Callbacks.onAddToCart();
          }
        },
        onError: function () {},
      });
    };

    OutputItem.prototype.removeHandler = function (e) {
      e.preventDefault();
      this.removeElement();
      this.callback();
    };

    OutputItem.prototype.removeElement = function () {
      WishList.remove(this.id);
      delete OutputItems[this.id];
      _setItemCount();
      this.item.remove();
    };

    OutputItem.prototype.callback = function () {
      typeof Callbacks.onRemove === 'function' ? Callbacks.onRemove() : '';
      if (WishList.memory.length === 0) {
        renderEmptyLayout();
      }
    };
  
  
    var _setItemCount = function() {
      var source = WishList.read();
      
      var count = 0;
      
      if (source && source.length > 0) {
        count = JSON.parse(WishList.read()).length;
        
        if (count > 9) {
          count = '+';
        }
      }
      
      
      
      if (Nodes.wishlist.countAll.length > 0) {
        Nodes.wishlist.countAll.forEach(function(item) {
          item.innerHTML = count;
        });
      }
    }
    
    
    var _handleClearAll = function() {
      WishList.clearStorage();
      window.location.reload();
    }

    setCallbacks = function (obj) {
      if (obj) {
        if (obj.onAddToCart) {
          Callbacks.onAddToCart = obj.onAddToCart;
        }
        if (obj.onRemove) {
          Callbacks.onRemove = obj.onRemove;
        }
      }
    };

    bindMainAddToCart = function () {
      var main = __assignNewNodes('wishlistMain');
      if (main.addall) {
        main.addall.addEventListener('click', mainAddToCartHandler);
      }
    };
  

    var _listenForClearAll = function() {
      var target = document.querySelector(Nodes.wishlist.selectors.clearList);
      if (target) {
        target.addEventListener('click', _handleClearAll);
      }
    }

    mainAddToCartHandler = function (e) {
      e.preventDefault();
      outputNodes = __assignNewNodes('output');
      if (outputNodes.checkedCheckboxesAll.length > 0) {
        var Variants = [];
        outputNodes.checkedCheckboxesAll.forEach(function (checkbox) {
          var _wishlistItem = OutputItems[checkbox.dataset.id];
          // will validate if variants are not selected
          var validation = _wishlistItem.validateVariant();
          if (validation) {
            var variantId = _wishlistItem.getVariantId();
            Variants.push({ quantity: '1', id: variantId });
          }
        });
        // if number of checkboxes matches the number of variant ids
        if (outputNodes.checkedCheckboxesAll.length == Variants.length) {
          _addToCartCall(Variants);
        }
      }
    };

    _addToCartCall = function (data) {
      WDN.Cart.Add({
        data: { items: data },
        onSuccess: function () {
          if (typeof Callbacks.onAddToCart === 'function') {
            Callbacks.onAddToCart();
            ajaxCart.load();
          }
        },
        onError: function () {},
      });
    };

    init = function (obj) {
      __initNodes();
      setCallbacks(obj);
      createInstance();
      _setItemCount();
      initOutput();
    };

    return { 
      Icons: Icons,
      OutputList: OutputItems,
      Init: init,
      refreshNodes: __initNodes
    };
  })();
}

WDN.Wishlist.Init({
  onAddToCart: function () {
    ajaxCart.load();
  },
  onRemove: function () {
  },
});


/*

// Replace quickpay image in checkout
var qp = document.querySelector('img[alt="QuickPay"]');
qp.src = "https://cdn.shopify.com/s/files/1/1473/2310/t/19/assets/payment-icons__footer_400x.png?v=15257576346188165822";
qp.style.height = '30px';
qp.style.marginTop = '-4px';

var creditCardLogosToRemove = document.querySelector('[data-brand-icons-for-gateway="119145482"]');
var mpLogoToRemove = document.querySelector('[data-brand-icons-for-gateway="118489034"]');
var mpLogoToReplaceSrc = document.querySelector('img[alt="MobilePay via QuickPay"]');

mpLogoToReplaceSrc.style.height = '30px';
mpLogoToReplaceSrc.style.marginTop = '-4px';
mpLogoToReplaceSrc.src = "https://cdn.shopify.com/s/files/applications/cc45d058246fa170ba58d32967680a6e.png?height=30&1548684876";

mpLogoToRemove.remove();
creditCardLogosToRemove.remove();

*/
